export function getView(selected) {
  if (!selected?.id) return 'Empty'

  return 'Content'
}
